export default {
  Cash: 1, // Tiền mặt
  Deposit: 2, // Tiền gửi
  Transfer: 3, // Chuyển khoản kho bạc
};
